<template>
  <v-card>
    <v-data-table :headers="headers" :items="items" :search="search" :items-per-page="15">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details />
          <v-spacer />
          <v-btn color="primary" to="/manage/edit/industrialProperties/add"><v-icon left>mdi-plus</v-icon>{{ $t("button.newItem") }}</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.property_type="{ item }">{{ $t(`form.industrial_property.types.${item.property_type}`) }}</template>
      <template v-slot:item.responsible="{ item }">{{ responsiblePersonName(item) }}</template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon color="primary" :to="`/manage/edit/industrialProperties/edit/${item.id}`"><v-icon>mdi-pencil</v-icon></v-btn>
        <v-btn icon color="error" @click="deleteItem(item)"><v-icon>mdi-delete</v-icon></v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import axios from "axios";
export default {
  name: "EditIndustrialPropertyList",
  data: () => ({ search: "", items: [], people: [] }),
  computed: {
    headers() {
      return [
        { text: this.$t("form.industrial_property.title"), value: "title" },
        { text: this.$t("table.responsible"), value: "responsible" },
        { text: this.$t("form.industrial_property.type"), value: "property_type" },
        { text: this.$t("form.industrial_property.application_number"), value: "application_number" },
        { text: this.$t("form.industrial_property.application_date"), value: "application_date" },
        { text: this.$t("actions"), value: "actions", sortable: false, align: "end" }
      ];
    }
  },
  created() {
    Promise.all([
      axios.get(`${this.$store.state.endpoint}/industrial_property`),
      axios.get(`${this.$store.state.endpoint}/personName`)
    ]).then(([items, people]) => {
      this.items = items.data;
      this.people = people.data;
    });
  },
  methods: {
    personFullName(personReference) {
      if (!personReference) {
        return "";
      }
      const person = personReference.person || personReference;
      if (person.preferred_name) {
        const given = person.preferred_name.given_name || "";
        const family = person.preferred_name.family_name || "";
        return `${given} ${family}`.trim();
      }
      const personId = person.id !== undefined ? person.id : personReference;
      const match = this.people.find(item => String(item.id) === String(personId));
      if (!match || !match.preferred_name) {
        return "";
      }
      return `${match.preferred_name.given_name || ""} ${match.preferred_name.family_name || ""}`.trim();
    },
    responsiblePersonName(item) {
      const people = item && Array.isArray(item.authors) && item.authors.length
        ? item.authors
        : item && item.internal_holders;
      return this.personFullName(Array.isArray(people) ? people[0] : people) || "-";
    },
    deleteItem(item) {
      if (!confirm(this.$t("message.confirm.delete"))) return;
      axios.delete(`${this.$store.state.endpoint}/industrial_property/${item.id}`).then(() => {
        this.items = this.items.filter(current => current.id !== item.id);
      });
    }
  }
};
</script>
